(function() {
    'use strict';

    angular
        .module('verificadocumentoApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('documento-ang', {
            parent: 'entity',
            url: '/documento-ang',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'verificadocumentoApp.documento.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/documento-ang/documentosang.html',
                    controller: 'DocumentoAngController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documento');
                    $translatePartialLoader.addPart('estadoDocumento');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('documento-ang-detail', {
            parent: 'documento-ang',
            url: '/documento-ang/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'verificadocumentoApp.documento.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/documento-ang/documento-ang-detail.html',
                    controller: 'DocumentoAngDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documento');
                    $translatePartialLoader.addPart('estadoDocumento');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Documento', function($stateParams, Documento) {
                    return Documento.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'documento-ang',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('documento-ang-detail.edit', {
            parent: 'documento-ang-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/documento-ang/documento-ang-dialog.html',
                    controller: 'DocumentoAngDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Documento', function(Documento) {
                            return Documento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('documento-ang.new', {
            parent: 'documento-ang',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/documento-ang/documento-ang-dialog.html',
                    controller: 'DocumentoAngDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                estadoDocumento: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('documento-ang', null, { reload: 'documento-ang' });
                }, function() {
                    $state.go('documento-ang');
                });
            }]
        })
        .state('documento-ang.edit', {
            parent: 'documento-ang',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/documento-ang/documento-ang-dialog.html',
                    controller: 'DocumentoAngDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Documento', function(Documento) {
                            return Documento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('documento-ang', null, { reload: 'documento-ang' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('documento-ang.delete', {
            parent: 'documento-ang',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/documento-ang/documento-ang-delete-dialog.html',
                    controller: 'DocumentoAngDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Documento', function(Documento) {
                            return Documento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('documento-ang', null, { reload: 'documento-ang' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('certificadodeestudios-firmado', {
            parent: 'entity',
            url: '/certificadodeestudios/{folioControl}',
            data: {
                pageTitle: 'verificadocumentoApp.documento.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/documento-ang/certificadodeestudios.html',
                    controller: 'CertificadoDeEstudiosController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documento');
                    $translatePartialLoader.addPart('estadoDocumento');
                    return $translate.refresh();
                }],           
                entity: ['$stateParams', 'CertificadoDeEstudios', function($stateParams, CertificadoDeEstudios) {
                    return CertificadoDeEstudios.get({folioControl : $stateParams.folioControl}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'documento-ang',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
          .state('documentoelectronico-firmado', {
            parent: 'entity',
            url: '/documentoelectronico/{folioControl}',
            data: {
                pageTitle: 'verificadocumentoApp.documento.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/documento-ang/documento-ang-detail.html',
                    controller: 'DocumentoAngDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documento');
                    $translatePartialLoader.addPart('estadoDocumento');
                    return $translate.refresh();
                }],           
                entity: ['$stateParams', 'Documento', function($stateParams, Documento) {
                    return Documento.get({folioControl : $stateParams.folioControl}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'documento-ang',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
          .state('documentoelectronico-firmado2', {
            parent: 'entity',
            url: '/{folioControl}',
            data: {
                pageTitle: 'verificadocumentoApp.documento.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/documento-ang/documento-ang-detail.html',
                    controller: 'DocumentoAngDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documento');
                    $translatePartialLoader.addPart('estadoDocumento');
                    return $translate.refresh();
                }],           
                entity: ['$stateParams', 'Documento', function($stateParams, Documento) {
                    return Documento.get({folioControl : $stateParams.folioControl}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'documento-ang',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        });
    }

})();
